import { Component } from '@angular/core';
import { StepService } from 'src/app/services/step.service';
import { ModularGoogleAnalyticsService } from '../../services/modular-google-analytics.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent {
  active: boolean;
  steps: number[];

  constructor(
    private modularGoogleAnalyticsService: ModularGoogleAnalyticsService,
    private stepService: StepService
  ) {
    this.steps = Array(this.stepService.maxStep - 1)
      .fill(x => x)
      .map((x, i) => i + 1);
  }

  openHelp() {
    this.modularGoogleAnalyticsService.sendEvent('help', 'open');
    this.active = true;
  }

  closeHelp() {
    this.modularGoogleAnalyticsService.sendEvent('help', 'close');
    this.active = false;
  }

  eventNinja(event: Event) {
    event.stopPropagation();
  }
}
